const initialState = {
	price_history: [],

	error: '',
	errorStatusCode: null,

	token: localStorage.getItem('token'),
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case 'USER_UNAUTHORIZED':
			state = {
				...state,
				loggingIn: false,
				error: action.payload.data.error,
				errorStatusCode: action.payload.status,
				fetchingPriceItem: false,
			};
			break;
		// item
		case 'FETCH_ITEM_PRICE_HISTORY_SUCCESS':
			state = {
				...state,
				price_history: action.payload,
				error: ''
			};
			break;
		case 'FETCH_ITEM_PRICE_HISTORY_FAILURE':
			state = {
				...state,
				price_history: [],
				error: action.payload.data.error.message,
				errorStatusCode: action.payload.status,
			};
			break;

		default:
			state = { ...state };
			break;
	}
	return state;
};

export default reducer;
